import React from 'react';

function PieChartIcon({
  size,
  styles,
  point,
  radius,
  perimeter,
  strokeWidth,
  refObj,
  id,
  ceilData,
}) {
  return (
    <svg
      height={size}
      width={size}
      className={styles.svg}
      viewBox={`0 0 ${size} ${size}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx={point}
        cy={point}
        r={radius}
        className={styles.bar}
        fill="transparent"
        stroke="#DFE0EB"
        strokeDasharray={perimeter}
        strokeLinecap="round"
        strokeWidth={strokeWidth}
      />
      <defs>
        <mask id={`mask${id}`}>
          <circle
            ref={refObj}
            cx={point}
            cy={point}
            r={radius}
            className={styles.valueCircle}
            stroke="white"
            strokeLinecap="round"
            strokeDasharray={perimeter}
            strokeWidth={strokeWidth}
            fill="none"
          />
        </mask>
      </defs>
      <foreignObject
        x="0"
        y="0"
        width={size}
        height={size}
        mask={`url(#mask${id})`}
      >
        <div
          style={{
            background: `conic-gradient(#ff8a00, #f45528 ${
              (ceilData / 100) * 360
            }deg)`,
            width: '100%',
            height: '100%',
          }}
        ></div>
      </foreignObject>
    </svg>
  );
}

export default PieChartIcon;
